export enum ImageUploadType {
  Simple,
  MultiSize,
  MultiSizeSplashScreen,
  Multiple
}
